import _ from 'lodash';
import { createSelector } from 'reselect';

import { AttendantCompanyTypeEnum } from 'constants/loanApplication';

import { selectLoanApplication } from './loanApplication.selectors';

const selectAttendantCompaniesState = createSelector(
  selectLoanApplication,
  ({ attendantCompanies }) => attendantCompanies,
);

const selectAttendantCompaniesList = createSelector(
  selectAttendantCompaniesState,
  ({ companies }) => companies,
);

export const selectAttendantCompaniesFeeProviderCategoryIdMap = createSelector(
  selectAttendantCompaniesState,
  ({ titleProviderCategoryId, escrowProviderCategoryId, attorneyProviderCategoryId }) => ({
    [AttendantCompanyTypeEnum.TITLE]: titleProviderCategoryId,
    [AttendantCompanyTypeEnum.ESCROW]: escrowProviderCategoryId,
    [AttendantCompanyTypeEnum.BUYER_ATTORNEY]: attorneyProviderCategoryId,
    [AttendantCompanyTypeEnum.SELLER_ATTORNEY]: attorneyProviderCategoryId,
  }),
);

export const selectAttendantCompaniesOptions = createSelector(
  selectAttendantCompaniesList,
  attendantCompanies =>
    _.sortBy(attendantCompanies, 'name').map(company => ({
      ...company,
      value: company.id,
    })),
);
